__turbopack_context__.v({
  "cardHolder": "fold-out-menu-module-scss-module__4hFEYa__cardHolder",
});
